import PolicyPage, { Section } from './PolicyPage'
import { PRODUCT_NAME } from '../content/provenance'

export default function SecurityPage() {
  return (
    <PolicyPage
      title="Security"
      intro={`How ${PRODUCT_NAME} is protected, and how to report something you have found.`}
    >
      <Section id="reporting" heading="Reporting a vulnerability">
        <p>
          Report privately through the repository&apos;s security advisories rather
          than a public issue. Include what you found, how to reproduce it, and what
          it would let an attacker do.
        </p>
        <p>
          Reports are acknowledged within three business days and assessed within
          ten. You will be told when the issue is resolved.
        </p>
      </Section>
      <Section id="transit" heading="In transit and at rest">
        <p>
          Every page and API endpoint requires HTTPS, with traffic encrypted in
          transit using TLS. Stored data is encrypted at rest under a
          customer-managed key with rotation enabled.
        </p>
      </Section>
      <Section id="pipeline" heading="What runs on every change">
        <p>
          Dependency audit, container image scanning, secret scanning, a passive
          dynamic scan of the running application, and infrastructure validation.
          Secret scanning also runs on a schedule.
        </p>
      </Section>
    </PolicyPage>
  )
}
